import React, { createContext, Component } from 'react';
import PropTypes from 'prop-types';

const ListingApp = createContext();
const Provider = ListingApp.Provider;

export class ListingProvider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...props.value,
		};
	}

	onUpdate = (newState) => {
		const { state } = this;
		this.setState({
			...state,
			...newState,
		});
	}

	render() {
		const { state, onUpdate } = this;
		const { children } = this.props;
		const value = {
			...state,
			onUpdate,
		};

		return (
			<Provider value={value}>
				{children}
			</Provider>
		);
	}
}

ListingProvider.propTypes = {
	children: PropTypes.node.isRequired,
	value: PropTypes.shape({
		likes: PropTypes.number,
		hasFavorited: PropTypes.bool,
	}),
};


/*
	* Provide children down the tree with access to this data
	* @param {Function} ReactStateless - Takes our state from above as params
*/
export const ListingConsumer = ListingApp.Consumer;
